var render, staticRenderFns
import script from "./budgetsChart.vue?vue&type=script&lang=js&"
export * from "./budgetsChart.vue?vue&type=script&lang=js&"
import style0 from "./budgetsChart.vue?vue&type=style&index=0&id=2e8a377f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a377f",
  null
  
)

export default component.exports